import { Injectable } from '@angular/core';
import { CookieService as NgxCookieService } from 'ngx-cookie-service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CookieService {
  // Options par défaut pour tous les cookies
  private readonly defaultOptions = {
    expiryDays: 30,
    path: '/',
    sameSite: 'Lax' as 'Lax' | 'None' | 'Strict'
  };
  
  // Domaine statique pour l'environnement de production
  private readonly productionDomain = 'lamas-ptr.digi4dev.ma';

  // Préfixe unique pour isoler les cookies de ce frontend
  private readonly cookiePrefix = 'ptr_';

  constructor(private ngxCookieService: NgxCookieService) {}
  
  // Stocke des données arbitraires dans les cookies avec sérialisation JSON
  setData(name: string, data: any): void {
    try {
      const serializedData = (data !== null && data !== undefined) ? JSON.stringify(data) : '';
      this.setCookie(name, serializedData);
    } catch (error) {
      console.error(`Erreur lors de l'enregistrement du cookie ${name}:`, error);
    }
  }

  // Récupère et désérialise les données depuis les cookies
  getData(name: string): any {
    try {
      const data = this.ngxCookieService.get(this.cookiePrefix + name);
      return data ? JSON.parse(data) : null;
    } catch (error) {
      console.error(`Erreur lors de l'analyse des données du cookie ${name}:`, error);
      return null;
    }
  }

  // Pose le cookie session indicator côté frontend après login réussi
  setSession(): void {
    this.setCookie('session', environment.appBuildId);
  }

  // Vérifie que le cookie session existe et correspond à appBuildId
  hasSession(): boolean {
    const value = this.ngxCookieService.get(this.cookiePrefix + 'session');
    return value === environment.appBuildId;
  }

  // Supprime uniquement les cookies de ce frontend (ceux qui commencent par le préfixe ptr_)
  removeCookies(): void {
    const domain = this.getDomain();

    // Supprimer uniquement les cookies de ce frontend (ceux qui commencent par le préfixe ptr_)
    const allCookies = this.ngxCookieService.getAll();
    Object.keys(allCookies)
      .filter(name => name.startsWith(this.cookiePrefix))
      .forEach(name => this.ngxCookieService.delete(name, this.defaultOptions.path, domain));
    
  }
  
  // Méthode interne pour définir des cookies avec des options cohérentes (préfixe appliqué automatiquement)
  private setCookie(name: string, value: string): void {
    const isSecure = window.location.protocol === 'https:';
    const domain = this.getDomain();

    this.ngxCookieService.set(
      this.cookiePrefix + name,
      value,
      this.defaultOptions.expiryDays,
      this.defaultOptions.path,
      domain,
      isSecure,
      this.defaultOptions.sameSite
    );
  }
  
  // Détermine le domaine à utiliser selon l'environnement
  private getDomain(): string | undefined {
    const { hostname } = window.location;
    
    // Pour localhost, pas de domaine
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      return undefined;
    }
    
    // Pour l'environnement de production, utiliser le domaine statique
    if (hostname.includes('lokabook.ma')) {
      return this.productionDomain;
    }
    
    // Pour d'autres environnements, utiliser la logique dynamique
    return hostname;
  }
}